import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import Notification from "./Notification";
import DeleteAccount from "./DeleteAccount";
import AboutUs from "./AboutUs";
import Payment from "./Payment";
import { isFeedFeatureEnabled } from "../../../utils/featureFlags";


function Settings() {
  const isPaymentEnabled = isFeedFeatureEnabled();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("about");

  useEffect(() => {
    const tabFromUrl = searchParams.get("activeTab");
    if (tabFromUrl) {
      setActiveTab(tabFromUrl);
    }
  }, [searchParams]);

  return (
    <div className="contianer">
      <div className={"tw-flex tw-flex-wrap [--grid-x:1.5rem] [--grid-y:0rem] tw-mx-[calc(var(--grid-x)_/_-2)] tw-mt-[calc(-1_*_var(--grid-y))] [:where(&)_>_*]:tw-shrink-[0] [:where(&)_>_*]:tw-w-full [:where(&)_>_*]:tw-max-w-full [:where(&)_>_*]:tw-px-[calc(var(--grid-x)_/_2)] [:where(&)_>_*]:tw-mt-[var(--grid-y)] ui-row"}>
        <div className="tw-min-w-[0px] ui-column tw-w-full">
          <div className="tw-min-h-full max-[768px]:tw-p-[16px] settings-container">
            {/* Settings Tabs */}
            <div className="tw-mb-0 settings-tabs-container">
              <div className={"tw-flex tw-border-b-[1px] tw-border-solid tw-border-b-[#e0e0e0] tw-overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:tw-hidden settings-tabs"}>
                {/* <button
                                    className={`settings-tab-item ${activeTab === 'account' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('account')}
                                >
                                    <Icon
                                        icon="fluent:person-24-regular"
                                        width="22"
                                        height="22"
                                        className="me-2"
                                    />
                                    Account Information
                                </button> */}

                <button
                  className={`tw-p-[12px_20px] tw-text-[15px] tw-font-medium tw-text-[#666] tw-bg-[none] tw-border-0 tw-border-b-[3px] tw-border-solid tw-border-b-[transparent] tw-cursor-pointer tw-whitespace-nowrap [transition:all_0.2s_ease] [&:hover]:tw-text-[#3152e8] [&.active]:tw-text-[#3152e8] [&.active]:tw-border-b-[#3152e8] max-[768px]:tw-p-[10px_16px] max-[768px]:tw-text-[14px] settings-tab-item   ${
                    activeTab === "about" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("about")}
                >
                  <Icon
                    icon="mdi:information-outline"
                    width="22"
                    height="22"
                    className="tw-me-2"
                  />
                  About Us
                </button>

                <button
                  className={`tw-p-[12px_20px] tw-text-[15px] tw-font-medium tw-text-[#666] tw-bg-[none] tw-border-0 tw-border-b-[3px] tw-border-solid tw-border-b-[transparent] tw-cursor-pointer tw-whitespace-nowrap [transition:all_0.2s_ease] [&:hover]:tw-text-[#3152e8] [&.active]:tw-text-[#3152e8] [&.active]:tw-border-b-[#3152e8] max-[768px]:tw-p-[10px_16px] max-[768px]:tw-text-[14px] settings-tab-item   ${
                    activeTab === "notifications" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("notifications")}
                >
                  <Icon
                    icon="fluent:alert-24-regular"
                    width="22"
                    height="22"
                    className="tw-me-2"
                  />
                  Account Settings
                </button>

                <button
                  className={`tw-p-[12px_20px] tw-text-[15px] tw-font-medium tw-text-[#666] tw-bg-[none] tw-border-0 tw-border-b-[3px] tw-border-solid tw-border-b-[transparent] tw-cursor-pointer tw-whitespace-nowrap [transition:all_0.2s_ease] [&:hover]:tw-text-[#3152e8] [&.active]:tw-text-[#3152e8] [&.active]:tw-border-b-[#3152e8] max-[768px]:tw-p-[10px_16px] max-[768px]:tw-text-[14px] settings-tab-item   ${
                    activeTab === "delete" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("delete")}
                >
                  <Icon
                    icon="fluent:delete-24-regular"
                    width="22"
                    height="22"
                    className="tw-me-2"
                    style={{
                      color: activeTab === "delete" ? "#dc3545" : "inherit",
                    }}
                  />
                  Delete Account
                </button>
                {isPaymentEnabled && (
                  <button
                    className={`tw-p-[12px_20px] tw-text-[15px] tw-font-medium tw-text-[#666] tw-bg-[none] tw-border-0 tw-border-b-[3px] tw-border-solid tw-border-b-[transparent] tw-cursor-pointer tw-whitespace-nowrap [transition:all_0.2s_ease] [&:hover]:tw-text-[#3152e8] [&.active]:tw-text-[#3152e8] [&.active]:tw-border-b-[#3152e8] max-[768px]:tw-p-[10px_16px] max-[768px]:tw-text-[14px] settings-tab-item   ${
                      activeTab === "payment" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("payment")}
                  >
                    <Icon
                      icon="mdi:credit-card-outline"
                      width="22"
                      height="22"
                      className="tw-me-2"
                    />
                    Payment
                  </button>
                )}

              </div>
            </div>

            {/* Tab Content */}
            <div className="tw-min-h-[400px] tw-overflow-visible settings-content-container">
           {/*    {activeTab === "account" && (
                <div className="settings-card">
                  <AccountInfo />
                </div>
              )} */}

              {activeTab === "notifications" && (
                <div className="tw-bg-[white] tw-rounded-[12px] tw-shadow-[0_4px_12px_rgba(0,_0,_0,_0.08)] tw-p-[24px] tw-overflow-visible max-[768px]:tw-p-[16px] settings-card">
                  <Notification />
                </div>
              )}

              {activeTab === "delete" && (
                <div className="tw-bg-[white] tw-rounded-[12px] tw-shadow-[0_4px_12px_rgba(0,_0,_0,_0.08)] tw-p-[24px] tw-overflow-visible max-[768px]:tw-p-[16px] settings-card">
                  <DeleteAccount />
                </div>
              )}

              {activeTab === "about" && (
                <div className="tw-bg-[white] tw-rounded-[12px] tw-shadow-[0_4px_12px_rgba(0,_0,_0,_0.08)] tw-p-[24px] tw-overflow-visible max-[768px]:tw-p-[16px] settings-card">
                  <AboutUs />
                </div>
              )}

              {isPaymentEnabled && activeTab === "payment" && (
                <div className="tw-bg-[white] tw-rounded-[12px] tw-shadow-[0_4px_12px_rgba(0,_0,_0,_0.08)] tw-p-[24px] tw-overflow-visible max-[768px]:tw-p-[16px] settings-card">
                  <Payment />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;
